export type SkillCategorySlug = 'sports' | 'skill' | 'school'

export type SkillCategoryOption = {
  id: string
  slug: SkillCategorySlug
}

// HER-349: the skill category taxonomy is fixed and has no list endpoint —
// these three rows are seeded once with deterministic UUIDs and never change,
// so the web admin hardcodes them rather than fetching a list. Must stay in
// sync with `SKILL_CATEGORY_IDS` in
// apps/server/src/database/seed-data/skill-categories.seed.ts.
export const SKILL_CATEGORIES: SkillCategoryOption[] = [
  { id: 'eac7e798-2bca-5df5-abe9-7ccfa94aad60', slug: 'sports' },
  { id: '8f4b3e22-9ccd-5a9f-9867-a47e07d1a6a5', slug: 'skill' },
  { id: 'c62b48ed-c519-5d06-a980-42c3047f973a', slug: 'school' },
]

// The server defaults a skill's category to 'skill' when `categoryId` is
// omitted on create (HER-349), so the web create form preselects the same
// category rather than leaving the select empty.
export const DEFAULT_SKILL_CATEGORY_ID = SKILL_CATEGORIES.find((category) => category.slug === 'skill')!.id
